module.exports = __webpack_public_path__ + "static/media/Icon-credit-card.cd03c3ac.svg";